import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const TYPELOCAL_URL = `${backendUrl}/api/typelocal/`;

class TypeLocalService {
	async getAllTypeLocals() {
		try {
			const response = await axios.get(TYPELOCAL_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getTypeLocal(id) {
		return axios.get(`${TYPELOCAL_URL}${id}/`);
	}

	createTypeLocal(data) {
		return axios.post(TYPELOCAL_URL, data);
	}

	updateTypeLocal(id, data) {
		return axios.put(`${TYPELOCAL_URL}${id}/`, data);
	}

	deleteTypeLocal(id) {
		return axios.delete(`${TYPELOCAL_URL}${id}/`);
	}

	getTypeLocalNames(TypeLocalIds) {
		return axios.get(`${TYPELOCAL_URL}?TypeLocalIds=${TypeLocalIds}`);
	}

	getTypeLocalOptions() {
		return this.getAllTypeLocals().then((TypeLocals) => {
			const options = TypeLocals.map((TypeLocal) => ({
				value: TypeLocal.id,
				label: TypeLocal.type.toUpperCase()
			}));
			// options.unshift({value: null, label: 'Selectionner la salle de TypeLocal'});
			return options;
		});
	}
}

export default new TypeLocalService();
